import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/bookonline-logo.svg'


const _hoisted_1 = { class: "flex flex-col gap-y-8 p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "block mx-auto w-4/5",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "border rounded" }
const _hoisted_4 = { class: "bg-gray-100 p-4 text-xl text-gray-700 font-semibold relative gap-2 flex justify-center" }
const _hoisted_5 = { class: "font-bold text-2xl text-center" }
const _hoisted_6 = { for: "email" }
const _hoisted_7 = { for: "password" }
const _hoisted_8 = { class: "flex flex-col items-end gap-y-2" }
const _hoisted_9 = {
  key: 0,
  class: "rounded-xl p-4 bg-green-200"
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  class: "underline font-semibold",
  href: "https://bookonline.ma",
  target: "_blank"
}

import FormErrors from "@/components/FormErrors.vue";
import { ref } from "vue";
import CButton from "@/components/Button.vue";
import PInput from "primevue/inputtext";
import PPassword from "primevue/password";
import useVuelidate from "@vuelidate/core";
import { cloneDeep } from "lodash";
import store from "@/store";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useNotify } from "@/composables/useNotify";
import LanguageSwitcher from "@/components/shared/languageSwitcher.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter();
const toast = useToast();
const { t } = useI18n();

const user = ref({ username: "", password: "" });
const isShowHowToResetPassword = ref(false);
const toggleShowHowToResetPassword = () => {
  isShowHowToResetPassword.value = !isShowHowToResetPassword.value;
};
const rules = store.getters["user/rulesToLogin"];
const v$ = useVuelidate(rules, user, { $lazy: true });
const { errorToast } = useNotify({ t });
const login = async () => {
  if (!(await v$.value.$validate())) {
    return;
  }
  try {
    await store.dispatch("user/LOGIN", cloneDeep(user.value));
    router.replace({ name: "Home" });
  } catch (e) {
    errorToast({ title: t("error"), error: "UNRECOGNIZED_CREDENTIALS" });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("login")), 1)
      ]),
      _createElementVNode("form", {
        class: "flex flex-col gap-y-8 p-8",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("email")), 1),
          _createVNode(_unref(PInput), {
            autocomplete: "username",
            class: "w-full",
            modelValue: user.value.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.username) = $event)),
            type: "email",
            id: "email"
          }, null, 8, ["modelValue"]),
          _createVNode(FormErrors, {
            errors: _unref(v$).username.$errors
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("password")), 1),
          _createVNode(_unref(PPassword), {
            "input-props": { autocomplete: 'current-password' },
            modelValue: user.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
            class: "w-full",
            type: "password",
            id: "password",
            feedback: false,
            "toggle-mask": ""
          }, null, 8, ["modelValue"]),
          _createVNode(FormErrors, {
            errors: _unref(v$).password.$errors
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CButton, {
            class: "!font-medium",
            onClick: login
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("login")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleShowHowToResetPassword())),
            class: _normalizeClass([{ 'underline text-blue-500': !isShowHowToResetPassword.value }, "cursor-pointer"])
          }, _toDisplayString(`${_ctx.$t("forgotPassword")}?`), 3)
        ]),
        (isShowHowToResetPassword.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("resetPasswordSteps")), 1))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _createVNode(LanguageSwitcher, { class: "mx-auto" }),
    _createElementVNode("div", _hoisted_10, [
      _createTextVNode(_toDisplayString(_ctx.$t("notYetAClient")) + " ", 1),
      _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("discoverBookonline")), 1)
    ])
  ]))
}
}

})